import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, FormsModule, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { DashboardService } from 'src/app/rest_services/dashboard.service';
import { MsSectorService } from 'src/app/rest_services/ms-sector.service';
import { SurveyService } from 'src/app/rest_services/msSurveyServices/survey.service';
import { SettingsService } from 'src/app/rest_services/settings.service';
import { getUniqueId } from 'src/app/rest_services/utilFunctions/functions_utiles';
import { VisitService } from 'src/app/rest_services/visit.service';
import {v4 as uuidv4} from 'uuid';

@Component({
  selector: 'app-complete-visit',
  templateUrl: './complete-visit.component.html',
  styleUrls: ['./complete-visit.component.css']
})
export class CompleteVisitComponent implements OnInit {

  msToken : any = '';
  id : any = '';
  toComplete : boolean = true;
  togenerateUuid:any=13;
  addedMsg:any ='';
  addError:any ='';
  imgWrap:any = "";
  imgArray:any[] = [];
  picturesVisit:any[]=[];
  picturesVisitUpdate:any[]=[];
  terminatedVisitForm:FormGroup;
  detail:any;
  perso:any;
  actions:any;
  terminer_plan:boolean=true;
  adaptedActions:any[]=[];
  sells:any[]=[];somme:any=0;
  successTerminatVisit:boolean=true;
  finalactions:any[]=[];

  constructor(
    private visitService:VisitService,
    private msSector : MsSectorService,
    private route: ActivatedRoute,
    private fb:FormBuilder,
    private settingsService:SettingsService,
    private dashboardServiceservice:DashboardService,
    private msSurvey : SurveyService,
    private location : Location
  ) { 
    this.terminatedVisitForm = this.fb.group({
      'contact_fullname': ['', [Validators.required, Validators.minLength(5), this.noSpecialCharactersValidator()]],
      'contact_function' : [''],
      'contact_phone' : ['', [Validators.pattern("^((\\+91-?)|0)?[0-9+]{10,13}$")]],
      'contact_email' : ['', [Validators.email,Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]]
    });
  }
  noSpecialCharactersValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const regex = /^[a-zA-Z ]+$/; 
      const valid = regex.test(control.value);
      return valid ? null : { 'invalidCharacters': true };
    };
  }
  surveyUuid :any;

  connectedComany:any;

  ngOnInit(): void {
    this.msToken = sessionStorage.getItem("msToken") || localStorage.getItem("msToken");

    if(localStorage.getItem("token")!=undefined) {
      this.APIToken = localStorage.getItem("token");
    }else if(sessionStorage.getItem("token")!=undefined){
      this.APIToken = sessionStorage.getItem("token");
    }
    let decodedJWT = JSON.parse(window.atob(this.APIToken.split('.')[1]));
    this.connectedComany = decodedJWT.company;
    this.id= this.route.snapshot.paramMap.get('cr')
    var fr= window.location.href.split( 'from');
    if(fr[1]!=undefined && fr.length>0){
      var from = fr[1].split(';')[0];      
      if(from=="Complete"){
        this.toComplete=true;
      } else{ 
        this.toComplete=false;  
      }
    }
    console.log(this.id);
    
    this.Detail(this.id);
    this.getConfig();
    var glob = this;
    // $('body').on('click', ".upload__img-close", function (e:any) {
    //   var file = $(this).parent().data("file");
    //   for (var i = 0; i < glob.imgArray.length; i++) {
    //     if (glob.imgArray[i].name === file) {
    //       glob.imgArray.splice(i, 1);
    //       glob.picturesVisit.splice(i, 1);
    //       break;
    //     }
    //   }
    //   $(this).parent().parent().remove();
    // });

    $('body').on('click', ".upload__img-close", function (e:any) {
      const imgUrl = $(this).parent().css('background-image').replace(/^url\("data:image\/png;base64,|"?\)$/g, '');
      const index = glob.picturesVisit.findIndex(picUrl => picUrl === imgUrl);
      if (index !== -1) {
          glob.picturesVisit.splice(index, 1);
      }
      $(this).parent().parent().remove();
    });
  }
  config: any = {
    skypeVisibility: false,
    zipCodeVisibility: false
  };
  getConfig(){
    this.settingsService.getConfig().subscribe(
      (resp: any) => {
        if(resp.code == "45859d1ba9e878f62c51935e3119d7ad"){
          this.config.survey = resp.config.survey;
        }
      },
      (err: any) => {
        console.log(err);
      }
    );
  }
  addPic(event :any) {
    const imgWrap = document.querySelector('.upload__img-wrap');
    const files = event.target.files;
    const glob =this;
  
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (!file.type.match('image.*')) continue;
        this.imgArray.push(file);
  
      const reader = new FileReader();
      reader.onload = function(e) {
        var imgBox = "<div class='upload__img-box'><div style='background-image: url(" + e.target?.result + ")' data-number='" + $(".upload__img-close").length + "' data-file='" + file.name + "' class='img-bg'><div class='upload__img-close'></div></div></div>";

        if (imgWrap) {
          imgWrap.innerHTML += imgBox;
          if (glob.picturesVisit == undefined || glob.picturesVisit == null) {
            glob.picturesVisit =[]
          }
          glob.picturesVisit?.push(e.target?.result);
        }
      };
  
      reader.readAsDataURL(file);
    }
  }
  isContactSelected: boolean = false;
  onContactSelected() {
    this.isContactSelected = true;
    setTimeout(() => {
      this.isContactSelected = false; 
    }, 8000); 
  }
  Detail(id:any){
    this.perso =[];
    this.terminer_plan=true;
    this.visitService.getDetail(id);
    this.visitService.detailSubject.subscribe(
      ( data: any ) => {
        this.terminer_plan=false;
        console.log(data);
        
        if(data.code =="9ee6b80261f5935fcdc9848ac558b605"){
          this.detail= data.visit;
          this.selectedContact = data.visit.selected_email??"";
          if(data.visit.contacted_persons !== undefined && data.visit.contacted_persons !== null)this.sells =  data.visit.contacted_persons;
          this.picturesVisit = data.visit.picturesVisit;
          // Display existing pictures
          const imgWrap = document.querySelector('.upload__img-wrap');
          if (imgWrap) {
              this.picturesVisit?.forEach((pictureUrl, index) => {
                  const imgBox = `<div class='upload__img-box'><div style='background-image: url(data:image/png;base64,${pictureUrl})' data-number='${index}' class='img-bg'><div class='upload__img-close'></div></div></div>`;
                  imgWrap.innerHTML += imgBox;
              });
          }
          this.msSector.getSector(this.msToken,this.detail?.visit_customer_sector).subscribe(
            (sectorLabel: any) => {
              this.detail.customer_sector = sectorLabel.label;
            },
            (error) => {
              console.log(error);
            }
          );
          this.perso= data.visit.actions;
          
          for(var ac of this.perso){
            var adaptedAction = {
              action: ac.action,
              action_comment: ac.action_comment,
              action_desc: ac.action_desc,
              status:"En cours",
              new:false
            }
            
            if(ac.action_status!=null){
              adaptedAction.status=ac.action_status;
            }
            this.adaptedActions.push(adaptedAction);
          }
          
          this.perso = this.adaptedActions;
        }
      },
    )  
  }

  verifylenght(event: any){
    if(event.target.value.length>0){
      var len:any = event.target.value.length-1;
      let toshowNumber:any = "<span>"+len+"/5000</span>";
      if(len<=5000){
        $("#lenght-"+event.target.id).html("<span style='color:green'"+toshowNumber+"</span>");
      }else {
        $("#lenght-"+event.target.id).html("<span style='color:red'"+toshowNumber+"</span>");
      }
    }else {
      $("#lenght-"+event.target.id).html("<span style='color:green'><span>0/5000</span></span>");
    }
  }

  removeAddedAction(uuid:any,list:any[]){
    let index = list.findIndex((d:any) => d.action === uuid);
    list.splice(index, 1);
  }

  verifylenghtNewComment(event: any){
    if(event.target.value.length>0){
      var len:any = event.target.value.length-1;
      let toshowNumber:any = "<span>"+len+"/5000</span>";
      if(len<=5000){
        $("#lenght-newComment").html("<span style='color:green'"+toshowNumber+"</span>");
      }else {
        $("#lenght-newComment").html("<span style='color:red'"+toshowNumber+"</span>");
      }
    }else {
      $("#lenght-newComment").html("<span style='color:green'><span>0/5000</span></span>");
    }
  }

  addNewAction(){
    // var checked = document.querySelector('input[name="statusAction"]:checked')as ;
    if($("#new_action").val()!=null && $("#new_action").val()!=" " 
      && $("#new_action").val()!=undefined && $("#new_action").val()!=""){
      var newAction:any={
        action: getUniqueId(this.togenerateUuid),
        action_comment: $("#new_comment").val(),
        action_desc: $("#new_action").val(),
        status:$("input[type='radio'][name='statusAction']:checked").val(),
        new:true
      };
      this.perso.push(newAction);
      this.togenerateUuid = this.togenerateUuid + 11;
      $("#new_comment").val(null as any);
      $("#new_action").val(null as any);
    }
  }

  addDetailToFinish() {
    if (this.terminatedVisitForm.valid) {
      const finishVisitFormValues = this.terminatedVisitForm.value;  
      // Check if the contact email already exists in sells
      const existingContact = this.sells.find(prod => prod.contact_email === finishVisitFormValues.contact_email);
      if (existingContact) {
        console.log("Contact already exists!");
      } else {
        this.sells.push(finishVisitFormValues);
      }
    } else {
      this.terminatedVisitForm.markAllAsTouched();
    }
    this.terminatedVisitForm.reset();
  }
  

  removeDetailToFinish(element:any){
    var item1 = this.sells.find(i => i === element);
    var index = this.sells.indexOf(item1);
    if (index !== -1) {
      this.sells.splice(index, 1);
      this.somme =this.somme - (item1.price*item1.product_unit);
      if (this.selectedContact === item1.contact_email) {
        this.selectedContact = '';
        this.isContactSelected = false;
      }
    }
  }
  updateStatus(action: any, status: string) {
    action.status = status;
}

  selectedContact!: string;
  terminateVisit(mode:any){
    this.toComplete = mode=='save'? false:true;
    $("html, body").animate({scrollTop:0});
    this.terminer_plan = true;
    for(var act of this.perso){
      var comment = document.getElementById(act.action) as HTMLTextAreaElement;
      
      var commentedaction = {
        "action": act.action,
        "action_desc": act.action_desc,
        "action_comment":comment.value,
        "action_status":act.status
      } 
      this.finalactions.push(commentedaction);
    }
    var body:any ={};
    body = {
      actions : this.finalactions,
      contacts : this.sells,
      pictures : this.picturesVisit,
      selected_email :this.selectedContact
    };
    
    this.dashboardServiceservice.bodyFinish = body;
    this.dashboardServiceservice.terminateVisit(this.id,mode);
    this.dashboardServiceservice.startVisitSubject.subscribe(
    ( data: any ) => {
      this.terminer_plan = false;
      if(data.code =="fe01fa6623c3648dcd4e15c482a2d602"){

        this.addedMsg = this.toComplete ? "Terminée avec succès" : "sauvegardée comme brouillon";
        $("#visit_terminated").show();
        $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
        });
        setTimeout(()=>{
          $("#visit_terminated").hide();
        }, 2000);
          if(this.selectedContact!='')this.initSurveyVisit();
      }else{
        $("#visit_not_terminated").show();
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
          });
          setTimeout(()=>{
            $("#visit_not_terminated").hide();
          }, 2000);
      }
    })
  }

  requestBody = {};
  APIToken:any = '';

  initSurveyVisit(){
    const selectedContactInfo = this.sells.find(prod => prod.contact_email === this.selectedContact);

    this.requestBody = {
      uuid_visit: this.id,
      contact_email: this.selectedContact,
      contact_fullName: selectedContactInfo?.contact_fullname,
      connected_company: this.connectedComany
    };

    this.msSurvey.initSurveyVisit(this.requestBody);
    this.msSurvey.initSurveyVisitSubject.subscribe(
      ( data: any ) => {
        this.stepBack();
      },
      (error: any) => {
        this.stepBack();
      }
    )
  }



  stepBack(){
    this.location.back();
  }
}
